import { render } from "./UserDropdown.vue?vue&type=template&id=4d5b518b"
import script from "./UserDropdown.vue?vue&type=script&lang=js"
export * from "./UserDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/shared/UserDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d5b518b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d5b518b', __exports__)) {
    api.reload('4d5b518b', __exports__)
  }
  
  module.hot.accept("./UserDropdown.vue?vue&type=template&id=4d5b518b", () => {
    api.rerender('4d5b518b', render)
  })

}


export default __exports__